import * as React from 'react';
import app from 'src/js/App';
import { useSelector } from 'react-redux';
import { REDUCER_GLOBAL_NAME } from 'moduleBase/constants';

var LangsMenuToggler = function LangsMenuToggler() {
  var languageSettings = useSelector(function (state) {
    return state[REDUCER_GLOBAL_NAME].languageSettings;
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("i", {
    className: "dropdown-flat-list__icon coll-icon coll-icon-globe"
  }), app.tForReact('catalog_channel_list', 'Language'), /*#__PURE__*/React.createElement("span", {
    className: "dropdown-flat-list__item__language color-858585"
  }, languageSettings.currentAsObject.name, /*#__PURE__*/React.createElement("i", {
    className: "fal fa-angle-right"
  })));
};

export { LangsMenuToggler };